







































import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import TagSearchAppend from '@/views/reports/pickers/tag-search-append.vue';

@Component({  
  components: {
    TagSearchAppend
  }
})
export default class TagSearchSelect extends Vue {
  @Prop()
  hideTags: boolean;
  
  @Prop()
  isShowClear: boolean;
  
  @Prop()
  hasMarks: boolean;
  
  @Prop()
  searchTags: string;
  
  @Prop()
  switchSearchMode: string;

  @Model('change')
  modelValue: any

  @Prop()
  value: any;

  get selected() {
    return this.switchSearchMode
  }

  set selected(value: string) {
    this.$emit('update:switchSearchMode', value);
  }
  
  get tags() {
    return this.modelValue
  }

  set tags(value) {
    this.$emit('change', value)
  }

}
